import { render } from "./CarouselNews.vue?vue&type=template&id=d47408ec"
import script from "./CarouselNews.vue?vue&type=script&lang=js"
export * from "./CarouselNews.vue?vue&type=script&lang=js"

import "./CarouselNews.vue?vue&type=style&index=0&id=d47408ec&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__